import jsonLdOrganization from './organization';

const host = `${process.env.NEXT_PUBLIC_HOST || 'https://mypersonality.net'}`;

const jsonLdWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${host}/#site`,
  url: `${host}`,

  potentialAction: {
    '@type': 'SearchAction',
    target: `${host}/search/{search_query}`,
    'query-input': 'required name=search_query',
  },

  producer: jsonLdOrganization,
  description:
    'Take our free 16 personality test to gain a deeper understanding of yourself and comprehend how your personality type influences your life.',

};

export default jsonLdWebSite;

